import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    fetchSpecificData,
    fetchSpecificDataSuccess,
    fetchSpecificDataFail,
    resetState,
    fetchAddressRecords,
    fetchAddressRecordsSuccess,
    fetchAddressRecordsFail
} from './member.action';
import { Member } from './member.model';

export interface MemberRecordsState {
    listData: Member[];
    singleData: Member;
    loading: boolean;
    error: any;
    total: number;
    memberData: {countryList: any[], clubs: any[]}
}

export const initialState: MemberRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    memberData: {countryList:[], clubs:[]}
};


export const MemberRecordReducer = createReducer(

    initialState,
    
    //Fetch All Records
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),


    //Fetch Address Records
    on(fetchAddressRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchAddressRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchAddressRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    
    //Fetch Specific Data
    on(fetchSpecificData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSpecificDataSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchSpecificDataFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //Fetch Single
    on(fetchSingleRecordSuccess, (state, { singleData, memberData }) => {
        return { ...state, singleData, memberData, loading: false, error: null };
    }),

    //Reset
    on(resetState, () => initialState)  // Reset action handler
    
);